<template>
  <div>
    <v-container grid-list-xl text-xs-center>
      <v-layout v-if="loading">
        <v-flex>
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm12>
          <div>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="appointments"
                :search="search"
                :loading="loadingTable"
              >

                <template slot="items" slot-scope="props"
                >
                  <td class="text-xs-center">{{ props.item.schedule_start_date }}</td>
                  <td class="text-xs-center">{{ props.item.schedule_start_time | formatHour }}</td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.first_name }}</td>
                  <td class="text-xs-center">{{ props.item.guardian1 }}</td>
                  <td class="text-xs-center">{{ props.item.guardian2 }}</td>
                  <td class="text-xs-center">
                    <v-btn
                      @click="getReport(props.item.family_id)"
                      color="primary">
                      {{ $t('admissions.council_form.report') }}
                    </v-btn>
                    <v-btn
                      @click="getForm(props.item.family_id)"
                      color="primary">
                      {{ $t('admissions.council_form.form') }}
                    </v-btn>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  Your search for "{{ search }}" found no results.
                </v-alert>
              </v-data-table>

            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-if="report"
      v-model="report_dialog"
      transition="dialog-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="report_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Reporte General Familia {{ report.last_name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <report
          :report="report"
        ></report>
        <v-layout row justify-center>
            <v-btn
            @click="report_dialog = false"
            color="primary">close</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-if="entry"
      v-model="form_dialog"
      transition="dialog-transition"
    >
      <v-card>
        <council
          :family="entry"
          :settings="settings"
        ></council>
        <v-layout row justify-center>
            <v-btn
            @click="form_dialog = false"
            color="primary">close</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import formatHour from "../../../libs/filter"
import Form from 'vform';
import axios from 'axios';
import report from './family_report'
import council from './council_appointment'
export default {
    name: "appointment-assistance",
    components: {
      'report': report,
      'council': council,
    },
    props: {
      appointments: {
        type: Array,
        required: true
      },
      settings: {
        type: Object,
        required: true
      }
    },
    data () {
        return {
            messageValidate: {
                delegateMessage: '',
                delegated_kinship: ''
            },
            form: new Form({
                schedule_id: null,
                assistMother: false,
                assistFather: true,
                signatureUrl: null,
                delegate: null,
                delegate_allowed: false,
                external_families: false,
                observation: null
            }),
            parents: [],
            event: [],
            loadingTable: false,
            loading: false,
            search: '',
            signatureEvent: false,
            report_dialog: false,
            form_dialog: false,
            family_id: null,
            quoteData: [],
            report: null,
            entry: null,
            headers: [
                { text: this.$t('admissions.council_form.date'), align: 'center', value: 'schedule_start_date' },
                { text: this.$t('admissions.council_form.time'), align: 'center', value: 'schedule_start_time' },
                { text: this.$t('admissions.council_form.family'), align: 'center', value: 'name' },
                { text: this.$t('admissions.council_form.prospect'), align: 'center', value: 'first_name' },
                { text: this.$t('admissions.council_form.guardian_1'), align: 'center', value: 'guardian1' },
                { text: this.$t('admissions.council_form.guardian_2'), align: 'center', value: 'guardian2' },
                { text: this.$t('admissions.council_form.action'), align: 'center', value: 'id', sortable: false }
            ],
        }
    },
    methods: {
      getReport(family_id) {
        this.family_id = family_id
        axios.get(`/api/admissions/entries/family/${family_id}`)
          .then(resp => {
            if (resp.status === 200) {
              this.report = resp.data
              this.report_dialog = true
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      getForm(family_id) {
        this.family_id = family_id
        axios.get(`/api/admissions/entries/family/${family_id}`)
          .then(resp => {
            if (resp.status === 200) {
              this.entry = resp.data
              this.form_dialog = true
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/appointment_assistance.vue